import { render, staticRenderFns } from "./Spo2.vue?vue&type=template&id=10fc6b82&"
import script from "./Spo2.vue?vue&type=script&lang=js&"
export * from "./Spo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports